<div class="custom-tooltip-wrapper" [ngClass]="{'right-tooltip': columnName === 'prop0'}">
  <div *ngIf="messages.length" class="custom-tooltip">
    <div *ngFor="let message of messages" class="custom-tooltip__item">
      <div *ngIf="message.label as label" class="tooltip-label">
        {{ label }}
      </div>
      <div class="tooltip-message">{{ message.text }}</div>
    </div>

    <mat-icon
      class="tooltip-icon"
      [class.animate]="animate"
      (click)="rollback()"
    >
      sync
    </mat-icon>
  </div>

  <ng-content />
</div>
